module.exports = __webpack_public_path__ + "static/media/95.9ff0d5ab.png";